import React, { Component } from 'react'
// import { useLocation, Link } from 'react-router-dom'
import RaisedButton from 'material-ui/RaisedButton'
import axios from 'axios'
import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'
import TextField from 'material-ui/TextField'
import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem'
import CircularProgress from 'material-ui/CircularProgress'
import format from 'date-fns/format'
import formatISO from 'date-fns/formatISO'
import addDays from 'date-fns/addDays'
import subMonths from 'date-fns/subMonths'
import addMonths from 'date-fns/addMonths'
import addMinutes from 'date-fns/addMinutes'
import addHours from 'date-fns/addHours'
import isBefore from 'date-fns/isBefore'
import isAfter from 'date-fns/isAfter'
import parseISO from 'date-fns/parseISO'
import differenceInDays from 'date-fns/differenceInDays'
import startOfToday from 'date-fns/startOfToday'
import areIntervalsOverlapping from 'date-fns/areIntervalsOverlapping'
import parse from 'date-fns/parse'
import min from 'date-fns/min'
import max from 'date-fns/max'
import differenceInMinutes from 'date-fns/differenceInMinutes'
import InfiniteCalendar from 'react-infinite-calendar'
import 'react-infinite-calendar/styles.css'
//import Recaptcha from 'react-recaptcha'
// import ReCAPTCHA from 'react-google-recaptcha'
import AspectRatio from '../AspectRatio'
import './style.css'

// const useQuery = () => new URLSearchParams(useLocation().search)
const useQuery = () => new URLSearchParams(window.location.search)
const mutateDate = (date, mutation) => {
  let newDate = date
  const entries = Object.entries(mutation)
  return entries.reduce((date, entry) => {
    const [type, value] = entry
    switch (type) {
      case 'minutes':
        return addMinutes(date, value)
      case 'hours':
        return addHours(date, value)
        break
      case 'days':
        return addDays(date, value)
        break
      case 'months':
        return addMonths(date, value)
        break
      case 'datetime':
        return parseISO(value)
        break
      default:
        break
    }
    return date
  }, date)
  entries.forEach(entry => {
    const type = entry[0]
    const value = entry[1]
    switch (type) {
      case 'minutes':
        newDate = addMinutes(date, value)
        break
      case 'hours':
        newDate = addHours(date, value)
        break
      case 'days':
        newDate = addDays(date, value)
        break
      case 'months':
        newDate = addMonths(date, value)
        break
      case 'datetime':
        newDate = parseISO(value)
        break
      default:
        break
    }
  })
  return newDate
}

class AppointmentCalendar extends React.PureComponent {
  state = {
    offset: {
      min: {
        minutes: 30,
      },
      max: {
        days: 30,
      },
    },
    days: {
      monday: {
        start: { time: 1000 },
        end: { time: 1900 },
      },
      tuesday: {
        start: { time: 1000 },
        end: { time: 1900 },
      },
      wednesday: {
        start: { time: 1000 },
        end: { time: 1900 },
      },
      thursday: {
        start: { time: 1000 },
        end: { time: 1900 },
      },
      friday: {
        start: { time: 1000 },
        end: { time: 1900 },
      },
      saturday: {
        start: { time: 1000 },
        end: { time: 1900 },
      },
      sunday: {
        start: { time: 1200 },
        end: { time: 1200 },
      },
    },
    session: {
      minutes: 15,
    },
    day_offset: 0,
    days_to_show: 7,
    calendarConfig: null,
    freeBusy: [],
    events: null,
    ready: false,

    timeDialogOpen: false,
    formDialogOpen: false,

    selectedDate: null,
    selectedTime: null,
  }

  componentDidMount() {
    this.getFreeBusy()
  }

  getFreeBusy = () => {
    const {
      data,
    } = this.props

    axios.get([
      data.api.endpoint,
      'calendar/freebusy',
    ].join('/'))
      .then((res) => {
        if (res.data && res.data.freeBusy) {
          // console.log('calendar/freebusy', res.data)

          const calendars = res.data.freeBusy.reduce((result, batch) => {
            const calendars = Object.keys(batch.calendars).map((id, index) => {
              return batch.calendars[id]
            })
            result = result.concat(calendars)

            return result
          }, [])

          const events = calendars.map((calendar, index) => {
            return calendar.busy
          }).reduce((events, busyArray) => {
            return [
              ...events,
              ...busyArray,
            ]
          }, [])

          const type = this.props.query.get('type')
          const today = new Date()
          const mcoEnd = new Date('2020-04-15T00:00:00')
          const isMco = isBefore(today, mcoEnd)
          const mco_calendarConfig = {
            blocks: [{
              type: 'period',
              start: {
                datetime: '2020-04-15T00:00:00+08:00',
              },
              end: {
                datetime: '2021-01-01T00:00:00+08:00',
              },
            }],
            days: {
              monday: {
                start: { time: 945 },
                end: { time: 1300 },
              },
              tuesday: {
                start: { time: 1300 },
                end: { time: 1600 },
              },
              wednesday: {
                start: { time: 945 },
                end: { time: 1300 },
              },
              thursday: {
                start: { time: 945 },
                end: { time: 1300 },
              },
              friday: {
                start: { time: 945 },
                end: { time: 1300 },
              },
              saturday: {
                start: { time: 945 },
                end: { time: 1300 },
              },
            },
            offset: {
              max: {
                datetime: '2020-04-14T23:00:00+08:00',
              },
              min: {
                // minutes: -720,
                hours: -12,
                days: -2,
              }
            },
            session: {
              minutes: 15,
            },
          }

          console.log({ events })

          this.setState({
            calendarConfig: isMco && type === 'online' ? mco_calendarConfig : res.data.calendarConfig,
            freeBusy: res.data.freeBusy,
            ready: true,
            events,
          })
        }
      })
  }

  closeTimeDialog = () => {
    this.setState({ timeDialogOpen: false })
  }

  closeFormDialog = () => {
    this.setState({ formDialogOpen: false })
  }

  selectTime = (selectedTime) => {
    this.setState({
      selectedTime,
      timeDialogOpen: false,
      formDialogOpen: true,
    })
  }

  onSelect = (selectedDate) => {
    // console.log('onSelect date:', selectedDate)
    this.setState({
      selectedDate,
      timeDialogOpen: true,
    })
  }

  addEvents = (dateTime) => {
    const {
      calendarConfig,
      events,
    } = this.state

    if (calendarConfig
      && calendarConfig.session
      && calendarConfig.session.minutes
    ) {
      events.push({
        start: dateTime,
        end: addMinutes(dateTime, calendarConfig.session.minutes)
      })
    }
  }

  render() {
    const { data, query, location } = this.props
    const {
      timeDialogOpen,
      formDialogOpen,
      ready,
      selectedDate,
      freeBusy,
      calendarConfig,
      events,
      selectedTime,
    } = this.state
    const today = new Date()

    if (!ready) {
      return (
        <div style={{
          padding: '1rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          <CircularProgress
            size={50}
            thickness={5}
            style={{
              padding: '1rem',
              marginLeft: '-3rem',
            }}
          />
          <h3>Loading Calendar</h3>
        </div>
      )
    }

    const disabledDatesA = Array(24).fill().map((_, index) => {
      return new Date(2017, 8, index + 1)
    })
    const activeDays = Object.keys(calendarConfig.days)
    const maxDate = mutateDate(today, calendarConfig.offset.max)
    const duration = Math.abs(differenceInDays(today, maxDate))
    // console.log({ duration, today, maxDate, activeDays })
    const disabledDatesB = Array(duration).fill().map((_, index) => {
      const date = addDays(today, index)
      const dayOfDate = format(date, 'EEEE').toLowerCase()
      // console.log({ dayOfDate })

      if (activeDays.indexOf(dayOfDate) < 0) {
        return date
      } else if (calendarConfig.days[dayOfDate].start.time === calendarConfig.days[dayOfDate].end.time) {
        return date
      }
      return void (0)
    })
    const disabledDates = disabledDatesA.concat(disabledDatesB.filter((date) => {
      return disabledDatesA.indexOf(date) < 0
    })).filter(Boolean)

    // console.log('InfiniteCalendar', {
    //   today,
    //   minDate: today,
    //   maxDate: addDays(today, calendarConfig.offset.max.days),
    //   min: subMonths(today, 1),
    //   max: addMonths(addDays(today, calendarConfig.offset.max.days), 1),
    //   disabledDates,
    // })

    return (
      <div className="appointment-calendar">
        <InfiniteCalendar
          today={today}
          min={mutateDate(today, calendarConfig.offset.min)}
          minDate={today}
          maxDate={mutateDate(today, calendarConfig.offset.max)}
          max={mutateDate(today, calendarConfig.offset.max)}
          width="100%"
          onSelect={this.onSelect}
          disabledDates={disabledDates}
        />
        <TimeDialog
          data={data}
          freeBusy={freeBusy}
          calendarConfig={calendarConfig}
          events={events}
          open={timeDialogOpen}
          closeDialog={this.closeTimeDialog}
          selectedDate={selectedDate}
          selectTime={this.selectTime}
        />
        <FormDialog
          data={data}
          open={formDialogOpen}
          closeDialog={this.closeFormDialog}
          selectedTime={selectedTime}
          addEvents={this.addEvents}
          query={query}
          location={location}
        />
      </div>
    )
  }
}

class TimeDialog extends React.PureComponent {
  state = {
    selectedTime: null,
  }

  closeDialog = () => {
    const {
      closeDialog,
    } = this.props

    this.setState({
      selectedTime: null,
    })

    closeDialog()
  }

  isBusy = (dateTime) => {
    const {
      events,
      calendarConfig: {
        blocks,
        session: {
          minutes,
        },
      },
    } = this.props

    const initialRangeStartDate = new Date(dateTime)
    const initialRangeEndDate = addMinutes(dateTime, minutes)

    const busy = !!events.find((event) => {
      // console.log('isBusy', {
      //   initialRangeStartDate,
      //   initialRangeEndDate,
      //   start: new Date(event.start),
      //   end: new Date(event.end),
      // })
      return areIntervalsOverlapping(
        { start: initialRangeStartDate, end: initialRangeEndDate },
        { start: new Date(event.start), end: new Date(event.end) }
      )
    })

    if (busy) {
      console.log({ busy })
      return busy
    }

    const blocked = Object.keys(blocks).reduce((blocked, key) => {
      const block = blocks[key]

      if (blocked) {
        return blocked
      }

      if (!!block
        && !!block.type
        && block.type === 'weekly'
        && !!block.day
        && !!block.start
        && !!block.start.time
        && !!block.end.time
        && block.day === format(dateTime, 'EEEE').toLowerCase()
      ) {
        console.log('blockStart', format(dateTime, 'yyyy-MM-dd') + ' ' + block.start.time)
        const blockStart = parse(format(dateTime, 'yyyy-MM-dd') + ' ' + block.start.time, 'yyyy-MM-dd HHmm', new Date())
        const blockEnd = parse(format(dateTime, 'yyyy-MM-dd') + ' ' + block.end.time, 'yyyy-MM-dd HHmm', new Date())
        // console.log('parse', { blockStart, blockEnd })

        // console.log('block weekly', { start: initialRangeStartDate, end: initialRangeEndDate },
        // { start: blockStart, end: blockEnd })
        return areIntervalsOverlapping(
          { start: initialRangeStartDate, end: initialRangeEndDate },
          { start: blockStart, end: blockEnd }
        )
      }

      if (!!block
        && !!block.type
        && block.type === 'period'
        && !!block.start
        && !!block.start.datetime
        && !!block.end
        && !!block.end.datetime
      ) {
        // console.log(parse(block.start.datetime))
        // console.log(parse(block.end.datetime))
        // console.log('block period', { start: initialRangeStartDate, end: initialRangeEndDate },
        // { start: new Date(block.start.datetime), end: new Date(block.end.datetime) })
        return areIntervalsOverlapping(
          { start: initialRangeStartDate, end: initialRangeEndDate },
          { start: new Date(block.start.datetime), end: new Date(block.end.datetime) }
        )
      }

      return blocked
    }, false)

    return blocked
  }

  render() {
    const {
      selectTime,
      open,
      data,
      freeBusy,
      calendarConfig,
      events,
      selectedDate,
    } = this.props

    // console.log('calendarConfig', calendarConfig)

    if (!calendarConfig || !selectedDate) {
      return null
    }

    // const min_time_start = min(...(Object.keys(calendarConfig.days).map((dayOfWeek, index) => {
    //   const day = calendarConfig.days[dayOfWeek]
    //   return parse(format(selectedDate, 'yyyy-MM-dd') + ' ' + day.start.time)
    // })))

    // const max_time_start = max(...(Object.keys(calendarConfig.days).map((dayOfWeek, index) => {
    //   const day = calendarConfig.days[dayOfWeek]
    //   return parse(format(selectedDate, 'yyyy-MM-dd') + ' ' + day.end.time)
    // })))

    const selectedDayOfWeek = format(selectedDate, 'EEEE').toLowerCase()
    // console.log({ selectedDayOfWeek, asd: calendarConfig.days })
    const min_time = parse(format(selectedDate,
      `yyyy-MM-dd ${calendarConfig.days[selectedDayOfWeek].start.time}`
    ), 'yyyy-MM-dd Hmm', new Date())
    const max_time = parse(format(selectedDate,
      `yyyy-MM-dd ${calendarConfig.days[selectedDayOfWeek].end.time}`
    ), 'yyyy-MM-dd Hmm', new Date())
    // console.log('parse', { min_time, max_time })

    const min_hour = parseInt(format(min_time, 'H'))
    const max_hour = parseInt(format(max_time, 'H'))
    const hour_difference = max_hour - min_hour

    // const slots = differenceInMinutes(max_time_start, min_time_start) / calendarConfig.session.minutes

    // console.log('min_time_start', min_time_start)
    // console.log('max_time_start', max_time_start)
    // console.log('slots', slots)
    // console.log('min_hour_start', min_hour_start)
    // console.log('max_hour_start', max_hour_start)
    // console.log('hour_difference', hour_difference)

    return (
      <Dialog
        title={format(selectedDate, 'EEEE, do MMM yyyy')}
        className="appointment-time-dialog"
        titleStyle={{
          textAlign: 'center',
        }}
        autoScrollBodyContent={true}
        open={open}
        contentStyle={{
          maxWidth: '35rem',
          width: 'calc(100vw - 2rem)',
        }}
        onRequestClose={this.closeDialog}
      >
        <div className="time-container">
          {Array(hour_difference).fill().map((_, index) => {
            // console.log('row', index)
            const hour = min_hour + index
            const slots_minute = 60 / calendarConfig.session.minutes
            return (
              <div className="time-row" key={index}>
                {Array(slots_minute).fill().map((_, index) => {
                  const minute = ('0' + (
                    calendarConfig.session.minutes * (index % slots_minute)
                  )).slice(-2)
                  const time = parse(format(selectedDate, 'yyyy-MM-dd') + ' ' + hour + minute, 'yyyy-MM-dd Hmm', new Date())
                  // console.log('parse', { time })
                  const isBusy = this.isBusy(time)
                  const inactive = isBefore(time, min_time) || isAfter(time, max_time)
                  console.log('slot', { time, isBusy, inactive })
                  return (
                    <div
                      className="time-column"
                      key={index}
                    >
                      <div className={`time${isBusy || inactive ? ' disabled' : ''}`}
                        onClick={() => (isBusy || inactive || selectTime(time))}
                      >
                        <div>{format(time, 'h:mm')}</div>
                        <div>{format(time, 'a')}</div>
                      </div>
                    </div>
                  )
                })}
              </div>
            )
          })}
        </div>
      </Dialog>
    )
  }
}

class FormDialog extends React.PureComponent {
  state = {
    name: '',
    email: '',
    phone: '',
    new_old: 'N',
    message: '',
    receipt: null,
    submitting: false,
    errorReceipt: null,
  }

  onSubmit = async (e) => {
    e.preventDefault()

    const formData = new FormData(e.target)
    const formValues = Object.fromEntries(formData.entries())

    const {
      name,
      email,
      phone,
      new_old,
      message,
      // appointmentDateTime,
      // recaptchaResponse,
      submitting,
      receipt,
    } = this.state

    if (submitting) {
      return false
    }

    const type = this.props.query.get('type')

    const {
      closeDialog,
      data,
      selectedTime,
      addEvents,
    } = this.props

    let newState = {
      errorName: null,
      errorEmail: null,
      errorPhone: null,
      errorReceipt: null,
    }

    let proceed = true

    const recaptchaResponse = formData.get('cf-turnstile-response')

    if (!name) {
      console.log('invalid name', name)
      newState.errorName = 'Name is required.'
      proceed = false
    }

    if (!email) {
      console.log('invalid email', email)
      newState.errorEmail = 'Email is required.'
      proceed = false
    }

    if (!phone) {
      console.log('invalid phone', phone)
      newState.errorPhone = 'Phone is required.'
      proceed = false
    }

    if (!recaptchaResponse) {
      console.log('invalid recaptchaResponse', recaptchaResponse)
      proceed = false
    }

    if (type === 'online' && !receipt) {
      // console.log('invalid phone', phone)
      newState.errorReceipt = 'Receipt is required.'
      proceed = false
    }

    if (!proceed) {
      this.setState(newState)
    } else {
      this.setState({ submitting: true })

      formData.append('name', name)
      formData.append('email', email)
      formData.append('phone', phone)
      formData.append('new_old', new_old)
      formData.append('selectedTime', formatISO(selectedTime))
      formData.append('message', message)
      formData.append('recaptchaResponse', recaptchaResponse)
      formData.append('type', type)
      formData.append('receipt', receipt)

      console.log('turnstile onSubmit', { e, formData, formValues })

      const url = [
        data.api.endpoint,
        'event/email',
      ].join('/')

      // console.log('POST', url)
      // for(var pair of formData.entries()) {
      //   console.log(pair[0]+ ', '+ pair[1]); 
      // }

      try {
        const res = await axios.post(url, {
          name,
          email,
          phone,
          new_old,
          selectedTime: formatISO(selectedTime),
          message,
          recaptchaResponse,
          type,
          receipt,
        })

        console.log(url, { res })
        // this.recaptcha.reset()
        if (this.turnstile) {
          this.turnstile.reset()
        }

        if (res.data.error) {
          let errorMessage = res.data.error.message
          if (res.data.errors) {
            errorMessage += '\n'
            errorMessage += Object.values(res.data.errors).join('\n')
          }

          this.setState({
            submitting: false,
          })

          return alert(errorMessage)
        }

        if (res.data.success) {
          alert(res.data.success.message)

          addEvents(selectedTime)
          closeDialog()

          // Event snippet for Ay Clinic- appointment booking conversion page
          if (window.gtag) {
            window.gtag('event', 'conversion', { 'send_to': 'AW-821680649/wH_LCMvcjnsQibTnhwM' })
          } else {
            console.log('gtag not available', window)
          }
        }

        this.setState({
          submitting: false,
          name: '',
          email: '',
          phone: '',
          new_old: 'N',
          message: '',
        })
      } catch (error) {
        alert('Connection error, please try again.')
        console.log('turnstile axios', { error })
        this.setState({
          submitting: false,
        })
      }

    }

    return false
  }

  setReceipt = () => {
    // console.log(this.fileReceipt.files && this.fileReceipt.files[0])
    this.setState({
      receipt: (this.fileReceipt.files && this.fileReceipt.files[0]) || null,
      errorReceipt: null,
    })
  }

  componentDidMount() {
    if (window.turnstile) {
      console.log('turnstile', 'didmount', window.turnstile)
      this.turnstile = window.turnstile
    }
  }

  render() {
    const {
      submitting,
      // recaptchaResponse,
      // appointmentDateTime,
      name,
      email,
      phone,
      new_old,
      message,
      errorName,
      errorEmail,
      errorPhone,
      errorReceipt,
    } = this.state
    const {
      open,
      closeDialog,
      selectedTime,
      query,
      // location,
    } = this.props

    const type = query.get('type')
    // console.log({ type })
    if (!selectedTime) { return null }

    if (this.turnstile && open && !this.widgetId) {
      console.log('turnstile', 'render', this.turnstile, this.props.data.turnstile)
      setTimeout(() => {
        this.widgetId = this.turnstile.render("#turnstile-container", {
          // sitekey: '1x00000000000000000000AA',
          sitekey: this.props.data.turnstile.sitekey,
          // callback: function (token) {
          //   console.log("turnstile Success:", token, document.querySelectorAll('input[name="token"]'));
          //   document.querySelector('input[name="token"]').value = token
          // },
        });
        console.log('turnstile', { widgetId: this.widgetId })
      }, 1000)
    }

    if (!open && this.widgetId) {
      this.widgetId = undefined
    }

    return (
      <Dialog
        title={type === 'online' ? 'Book Online Consultation' : 'Book Your Appointment'}
        id="AppointmentFormDialog"
        titleStyle={{
          textAlign: 'center',
        }}
        autoScrollBodyContent={true}
        open={open}
        contentStyle={{
          maxWidth: 'calc(100vw - 2rem)',
          width: '50rem',
        }}
        onRequestClose={closeDialog}
      >
        <div style={{ textAlign: 'center', paddingTop: '1rem' }}>
          <h3 style={{ margin: '.5rem 0', textAlign: 'center' }}>
            {format(selectedTime, 'h:mm a, EEEE')}
          </h3>
          <h3 style={{ margin: '.5rem 0', textAlign: 'center' }}>
            {format(selectedTime, 'do MMM yyyy')}
          </h3>
        </div>
        <form onSubmit={this.onSubmit}>
          <TextField
            floatingLabelText="Name"
            hintText="Your Name"
            autoFocus={true}
            onChange={(event, name) => this.setState({
              name,
              errorName: null,
            })}
            floatingLabelFixed={true}
            fullWidth={true}
            errorText={errorName}
          />
          <TextField
            floatingLabelText="Email"
            hintText="Email Address"
            onChange={(event, email) => this.setState({
              email,
              errorEmail: null,
            })}
            floatingLabelFixed={true}
            fullWidth={true}
            type="email"
            errorText={errorEmail}
          />
          <TextField
            floatingLabelText="Phone"
            hintText="Contact Number"
            onChange={(event, phone) => this.setState({
              phone,
              errorPhone: null,
            })}
            floatingLabelFixed={true}
            fullWidth={true}
            errorText={errorPhone}
          />
          <SelectField
            floatingLabelText="I am a"
            value={new_old}
            fullWidth={true}
            onChange={(event, index, new_old) => this.setState({ new_old })}
          >
            <MenuItem value="N" primaryText="New Patient" />
            <MenuItem value="F" primaryText="Follow-up Patient" />
          </SelectField>
          <TextField
            floatingLabelText="Purpose of Appointment"
            hintText="What is the appointment about?"
            onChange={(event, message) => this.setState({ message })}
            floatingLabelFixed={true}
            multiLine={true}
            rowsMax={2}
            maxLength={60}
            fullWidth={true}
          />
          <div style={{
            fontSize: '.75rem',
            textAlign: 'right',
            fontStyle: 'italic',
            color: '#aaa',
          }}>
            {`${message.length}/60`}
          </div>
          {type === 'online' &&
            <div style={{ marginBottom: '1rem' }}>
              <div style={{
                color: '#2a3890',
                border: '0.25rem #2a3890 solid',
                boxShadow: '0 1rem 3rem rgba(0, 0, 0, 0.1)',
                backgroundColor: '#fff',
                margin: '1rem 1rem 2rem',
                padding: '0 1rem',
              }}>
                <p>
                  If you would like to proceed to request an online consultation,
                  the charge would be <strong>RM 100</strong> payable by online transfer
                  (discounted normal specialist rate of up to RM 230 as stipulated by the Malaysian Medical Association)
                </p>
                <p>
                  Please kindly make the payment to:
                </p>
                <dl>
                  <dt><strong>Bank</strong></dt>
                  <dd>CIMB</dd>
                  <dt><strong>Account Name</strong></dt>
                  <dd>AY Skin Specialist & Aesthetic Centre PLT</dd>
                  <dt><strong>Account Number</strong></dt>
                  <dd>800 827 4646</dd>
                </dl>
                <p>
                  Please attach your payment receipt below.
                </p>
              </div>
              <div>
                <label style={{ fontSize: '0.75rem', color: '#2a3890' }}>Bank Payment Receipt</label>
              </div>
              <div style={{ margin: '.25rem 0' }}>
                <input type="file" ref={(ref) => { this.fileReceipt = ref }} onChange={this.setReceipt} />
              </div>
              {!!errorReceipt ? (
                <div style={{ fontSize: '0.75rem', color: 'red' }}>{errorReceipt}</div>
              ) : (
                <div style={{ fontSize: '0.75rem' }}>
                  Upload your bank payment receipt here
                </div>
              )}
            </div>
          }
          <div id="turnstile-container" />
          {/* <div
          class="cf-turnstile"
          data-sitekey={this.props.data.turnstile.sitekey}
          data-theme="light"
          data-size="normal"
          data-action="appointment"
          // data-callback="onSuccess"
        /> */}
          {/* <ReCAPTCHA
        ref={(ref) => {
          this.recaptcha = ref
        }}
        sitekey={this.props.data.recaptcha.sitekey}
        size="normal"
        className="recaptcha-container"
        onChange={(recaptchaResponse) => {
          console.log('recaptchaResponse', recaptchaResponse)
          this.setState({ recaptchaResponse })
        }}
        badge="inline"
      /> */}
          <div style={{
            paddingTop: '2rem',
            textAlign: 'right',
          }}>
            <FlatButton label="Cancel"
              onClick={closeDialog}
            />
            <FlatButton label="Submit"
              primary={true}
              // onClick={this.submitBooking}
              type="submit"
              // disabled={!name || !email || !phone || !new_old || !recaptchaResponse || submitting}
              disabled={!name || !email || !phone || !new_old || submitting}
            />
          </div>
        </form>
      </Dialog>
    )
  }
}

// class Appointment extends Component {
//   render() {
//     const { data } = this.props

//     return (
//       <div className="appointment">
//         <div className="container">
//           <h1 className="title">Book Appointment</h1>
//           <div className="content">
//             <AppointmentCalendar data={data} />
//           </div>
//         </div>
//       </div>
//     )
//   }
// }

const Appointment = ({
  data,
}) => {
  const query = useQuery()
  // const location = useLocation()
  const type = query.get('type')
  return (
    <div className="appointment">
      <div className="container">
        <h1 className="title" style={{ color: '#2a3890' }}>
          {type === 'online' ? 'Online Consultation' : 'Book Appointment'}
        </h1>
        <div className="content">
          <AppointmentCalendar data={data} query={query} location={window.location} />
        </div>
      </div>
    </div>
  )
}

export default Appointment



// WEBPACK FOOTER //
// ./src/components/Appointment/index.js